// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CFVr","toggleWrap":"styles_toggleWrap__1gp37","content":"styles_content__2uCqf","selectAreaCode":"styles_selectAreaCode__3Tke6"};